import { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useClienteAuth } from '../../context/ClienteAuthContext';
import toast from 'react-hot-toast';

const INPUT_STYLE = {
  padding: '13px 14px',
  borderRadius: 12,
  border: '1.5px solid #e8e4de',
  fontSize: '16px',
  fontFamily: "'Sora', sans-serif",
  background: '#fff',
  outline: 'none',
  width: '100%',
  boxSizing: 'border-box',
  WebkitAppearance: 'none',
};

export default function LoginCliente() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get('redirect') || '/cliente/conta';
  const empresaId = params.get('empresa_id');
  const { loginCliente, registrarCliente } = useClienteAuth();

  const [aba, setAba] = useState('entrar'); // 'entrar' | 'cadastro'
  const [loading, setLoading] = useState(false);

  // Entrar
  const [loginForm, setLoginForm] = useState({ email: '', senha: '' });

  // Cadastro
  const [cadForm, setCadForm] = useState({
    nome: '', email: '', telefone: '', senha: '', confirmarSenha: '',
  });

  const LF = (k, v) => setLoginForm(p => ({ ...p, [k]: v }));
  const CF = (k, v) => setCadForm(p => ({ ...p, [k]: v }));

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!loginForm.email || !loginForm.senha) {
      toast.error('Preencha email e senha');
      return;
    }
    if (!empresaId) {
      toast.error('Loja não identificada. Acesse pelo link do cardápio.');
      return;
    }
    setLoading(true);
    try {
      await loginCliente(loginForm.email, loginForm.senha, empresaId);
      toast.success('Bem-vindo(a)!');
      navigate(redirect, { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.erro || 'Credenciais inválidas');
    } finally {
      setLoading(false);
    }
  };

  const handleCadastro = async (e) => {
    e.preventDefault();
    if (!cadForm.nome || !cadForm.email || !cadForm.senha) {
      toast.error('Nome, email e senha são obrigatórios');
      return;
    }
    if (cadForm.senha !== cadForm.confirmarSenha) {
      toast.error('As senhas não coincidem');
      return;
    }
    if (!empresaId) {
      toast.error('Loja não identificada. Acesse pelo link do cardápio.');
      return;
    }
    setLoading(true);
    try {
      await registrarCliente({
        nome: cadForm.nome,
        email: cadForm.email,
        telefone: cadForm.telefone,
        senha: cadForm.senha,
        empresa_id: empresaId,
      });
      toast.success('Conta criada! Faça login para continuar.');
      // Após cadastro, preenche email no login e muda de aba
      setLoginForm({ email: cadForm.email, senha: '' });
      setAba('entrar');
    } catch (err) {
      toast.error(err.response?.data?.erro || 'Erro ao criar conta');
    } finally {
      setLoading(false);
    }
  };

  const tabStyle = (ativo) => ({
    flex: 1,
    padding: '12px',
    border: 'none',
    borderBottom: `3px solid ${ativo ? '#FF6B35' : 'transparent'}`,
    background: 'none',
    fontFamily: "'Sora', sans-serif",
    fontWeight: ativo ? 800 : 600,
    fontSize: '.9rem',
    color: ativo ? '#FF6B35' : '#888',
    cursor: 'pointer',
    transition: 'all .15s',
  });

  return (
    <div style={{ minHeight: '100dvh', background: '#F8F7F4', fontFamily: "'Sora', sans-serif" }}>
      {/* Header */}
      <header style={{
        background: '#1A1A2E',
        padding: '16px 20px',
        paddingTop: 'max(16px, env(safe-area-inset-top))',
      }}>
        <div style={{ maxWidth: 480, margin: '0 auto', display: 'flex', alignItems: 'center', gap: 12 }}>
          <button onClick={() => navigate(-1)} style={{
            background: 'rgba(255,255,255,.1)', border: 'none', color: '#fff',
            borderRadius: 10, width: 38, height: 38, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem',
            flexShrink: 0,
          }}>←</button>
          <h1 style={{ color: '#fff', fontSize: '1rem', fontWeight: 800, margin: 0 }}>
            Minha Conta
          </h1>
        </div>
      </header>

      <div style={{ maxWidth: 480, margin: '0 auto', padding: '24px 16px' }}>
        <div style={{ background: '#fff', borderRadius: 20, overflow: 'hidden',
          boxShadow: '0 4px 24px rgba(0,0,0,.07)' }}>

          {/* Abas */}
          <div style={{ display: 'flex', borderBottom: '1px solid #eee' }}>
            <button style={tabStyle(aba === 'entrar')} onClick={() => setAba('entrar')}>
              Entrar
            </button>
            <button style={tabStyle(aba === 'cadastro')} onClick={() => setAba('cadastro')}>
              Criar conta
            </button>
          </div>

          <div style={{ padding: '24px 24px 28px' }}>
            {aba === 'entrar' ? (
              <>
                <p style={{ color: '#888', fontSize: '.85rem', marginBottom: 20, margin: '0 0 20px' }}>
                  Salve seus dados e veja seu histórico de pedidos.
                </p>
                <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <label style={{ fontSize: '.8rem', fontWeight: 700, color: '#444' }}>E-mail *</label>
                    <input
                      type="email" value={loginForm.email}
                      onChange={e => LF('email', e.target.value)}
                      placeholder="seu@email.com"
                      style={INPUT_STYLE}
                      onFocus={e => e.target.style.borderColor = '#FF6B35'}
                      onBlur={e => e.target.style.borderColor = '#e8e4de'}
                    />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <label style={{ fontSize: '.8rem', fontWeight: 700, color: '#444' }}>Senha *</label>
                    <input
                      type="password" value={loginForm.senha}
                      onChange={e => LF('senha', e.target.value)}
                      placeholder="Sua senha"
                      style={INPUT_STYLE}
                      onFocus={e => e.target.style.borderColor = '#FF6B35'}
                      onBlur={e => e.target.style.borderColor = '#e8e4de'}
                    />
                  </div>
                  <button type="submit" disabled={loading} style={{
                    marginTop: 4,
                    background: loading ? '#ccc' : '#FF6B35',
                    color: '#fff', border: 'none', borderRadius: 14,
                    padding: '14px', fontWeight: 800, fontSize: '1rem',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    fontFamily: 'inherit',
                    boxShadow: loading ? 'none' : '0 4px 16px rgba(255,107,53,.3)',
                  }}>
                    {loading ? 'Entrando...' : 'Entrar na conta'}
                  </button>
                </form>
                <div style={{ textAlign: 'center', marginTop: 16 }}>
                  <button
                    onClick={() => navigate(`/cliente/esqueci-senha${empresaId ? `?empresa_id=${empresaId}` : ''}`)}
                    style={{
                      background: 'none', border: 'none', color: '#FF6B35',
                      fontSize: '.82rem', fontWeight: 700, cursor: 'pointer',
                      fontFamily: 'inherit', textDecoration: 'underline',
                    }}
                  >
                    Esqueci minha senha
                  </button>
                </div>
              </>
            ) : (
              <>
                <p style={{ color: '#888', fontSize: '.85rem', marginBottom: 20, margin: '0 0 20px' }}>
                  Crie sua conta para salvar endereços e acompanhar pedidos.
                </p>
                <form onSubmit={handleCadastro} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                  {[
                    { label: 'Nome completo *', key: 'nome', type: 'text', placeholder: 'Seu nome' },
                    { label: 'E-mail *', key: 'email', type: 'email', placeholder: 'seu@email.com' },
                    { label: 'Telefone / WhatsApp', key: 'telefone', type: 'tel', placeholder: '(11) 99999-0000' },
                    { label: 'Senha *', key: 'senha', type: 'password', placeholder: 'Mínimo 6 caracteres' },
                    { label: 'Confirmar senha *', key: 'confirmarSenha', type: 'password', placeholder: 'Repita a senha' },
                  ].map(({ label, key, type, placeholder }) => (
                    <div key={key} style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                      <label style={{ fontSize: '.8rem', fontWeight: 700, color: '#444' }}>{label}</label>
                      <input
                        type={type} value={cadForm[key]}
                        onChange={e => CF(key, e.target.value)}
                        placeholder={placeholder}
                        style={INPUT_STYLE}
                        onFocus={e => e.target.style.borderColor = '#FF6B35'}
                        onBlur={e => e.target.style.borderColor = '#e8e4de'}
                      />
                    </div>
                  ))}
                  <button type="submit" disabled={loading} style={{
                    marginTop: 4,
                    background: loading ? '#ccc' : '#FF6B35',
                    color: '#fff', border: 'none', borderRadius: 14,
                    padding: '14px', fontWeight: 800, fontSize: '1rem',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    fontFamily: 'inherit',
                    boxShadow: loading ? 'none' : '0 4px 16px rgba(255,107,53,.3)',
                  }}>
                    {loading ? 'Criando conta...' : 'Criar conta'}
                  </button>
                </form>
              </>
            )}

            <p style={{ textAlign: 'center', marginTop: 20, fontSize: '.75rem', color: '#bbb' }}>
              Ao continuar você concorda com nossa{' '}
              <Link to="/pagina/privacidade" style={{ color: '#FF6B35', textDecoration: 'none' }}>
                Política de Privacidade
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
